<template>
  <div class="modal fade" tabindex="-1" :id="'kt_modal_' + id">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('departmentUser.create_user') }}</h5>
          <div @click="closeModal" class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                  </svg>
              </span>
          </div>
        </div>

        <div class="modal-body">
          <div style="margin-left:-1%; margin-bottom:2%">
            <RequiredText />
          </div>
          <form id="kt_modal_new_target_form" @submit.prevent="submitAddUser" class="form" >

            <Select2
              containerClass="col-md-12 mb-5"
              name="users"
              :label="$t('title_department_user')"
              labelClass="d-flex align-items-center fs-6 fw-bold mb-2"
              :multiple="true"
              :selectClass="'form-select form-select-solid selectUserGroup'"
              :isRequired="true"
              :placeholderText="$t('group.users_placeholder')"
              :parentId="'#kt_modal_' + id"
              v-model="form.ids">
              <option v-for="user in filteredUsers" :key="user.id" :value="user.id">{{ user?.lastname }}   {{ user?.firstname }}</option>                
            </Select2>
            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { useStore } from "vuex";
import {useI18n} from "vue-i18n";
import {nextTick, onMounted, ref, watch} from "vue"
import RequiredText from "@/components/RequiredText"
import { useLocales } from "@/composables/locales";
import Select2 from "@/components/Select2.vue"
import Button from "@/components/Button"

const props = defineProps({
  id: {
    type: String,
    default: 'kt_modal_'
  },
  edit: {
    type: Boolean,
    default: false
  },
  editForm : {
    type: Object,
    required: false
  },
  departmentId:String,
  reloadUsers: {
    type: Boolean,
    default: false
  },

})

const store = useStore()

const emit = defineEmits(['reloadDatatable'])

const isLoading = ref(false)

const { t } = useI18n({ useScope: 'global' })
const { locale } = useLocales();

const getUsers = ref([])
const filteredUsers  = ref([])
const form = ref({
  name: '',
  ids: []
})


watch(() =>  getUsers.value, (value) => {
  if(value){
    filteredUsers.value = getUsers.value.filter(user => user.department_id === null)
  }
})

watch(() =>  props.reloadUsers, (value) => {
  if(value){
    getAccesUsers()
    props.reloadUsers=false
  }
})

onMounted(() => {
  getAccesUsers()
  initUserSelect2()
})

const getAccesUsers = async () => {
  try
  {
    let response = await store.dispatch('department/getUsers')
    getUsers.value=response.data.users
  }catch (e) {
  }
}

function resetFormValue(){
  form.value = {
    name: '',
    ids: []
  }
  nextTick(() => {
    initUserSelect2()
  })
}

function initUserSelect2(){

  let selectUserGroup = $('.selectUserGroup')

  selectUserGroup.select2()
  selectUserGroup.select2().select2()

  selectUserGroup.on('change', (e) => {
    if(e.target.value){
      let result = [];
      for (var i = 0, iLen = e.target.selectedOptions.length; i<iLen; i++) {
        if(e.target.selectedOptions[i].value != '' || e.target.selectedOptions[i].value != undefined){
          result.push(e.target.selectedOptions[i].value);
        }
      }
      form.value.ids = result
    }else{
      form.value.ids = []
    }
  })

}

function submitAddUser () {
  storeUserDepartment()
  form.value.ids=[]
}

function closeModal(){
  getAccesUsers()
  resetFormValue()
  props.reloadUsers=false
  $("#kt_modal_" + props.id).modal('hide')
}

async function storeUserDepartment () {
  const data = {users:form.value.ids, department_id:props.departmentId}
  isLoading.value = true
  try
  {
    await store.dispatch('department/AddUsersToDepartment', data)
    isLoading.value = false
    closeModal()
    window.toastr.success(t('notification.departmentUser_added'))
  }catch (e) {
    isLoading.value = false
  }
  emit('reloadDatatable')

}

</script>
